/* @flow */

import React from 'react';
import type { $Dealer } from 'CoreTypes';
import type { $Translation } from 'CoreTypes';
import type { $TooltipPosition } from '../WorkbenchTooltip/WorkbenchTooltip';
import DealerActivityTypes from '../../constants/DealerActivityTypes';
import DealerKeys from '../../constants/WidgetDealerKeys';
import Icons from '../WorkbenchIcon/WorkbenchIcons';
import WorkbenchIcon from '../WorkbenchIcon/WorkbenchIcon';
import WorkbenchTooltip from '../WorkbenchTooltip/WorkbenchTooltip';
import { getActivityTypesSetFromDealer } from '../../utils/DealerUtils';
import { getActivityTypeDealerDynamicFieldKey } from '../../utils/TranslationUtils';
import { mapDealerActivityTypeToTranslation } from '../../utils/DealerUtils';
import { isHiddenField } from '../../utils/WidgetUtils';

type $Props = {
  dealer: $Dealer,
  translations: Array<$Translation>,
  settings?: ?Object,
  tooltipPosition?: $TooltipPosition
};

const dealerActivityIcons = {
  [DealerActivityTypes.PARTS]: Icons.ICO_ACTIVITIES_PARTS,
  [DealerActivityTypes.SALES]: Icons.ICO_ACTIVITIES_NEW_VEHICLES,
  [DealerActivityTypes.SERVICE]: Icons.ICO_ACTIVITIES_SERVICE,
  [DealerActivityTypes.USED_VEHICLES_TRADE]: Icons.ICO_ACTIVITIES_USED_VEHICLES
};

const DealerActivities = (props: $Props) => {
  const { dealer, translations } = props;
  const settings = props.settings || {};

  const dealerActivityTypes = getActivityTypesSetFromDealer(dealer);

  const dealerActivityTypesTranslations: Map<string, string> = new Map();
  const dealerActivityTypesVisibility: Map<string, boolean> = new Map();

  dealerActivityTypes.forEach((activityType: string) => {
    dealerActivityTypesTranslations.set(
      activityType,
      mapDealerActivityTypeToTranslation(translations, activityType)
    );
    dealerActivityTypesVisibility.set(
      activityType,
      !isHiddenField(settings, getActivityTypeDealerDynamicFieldKey(activityType))
    );
  });

  if (dealerActivityTypes && dealerActivityTypes.length > 0 &&
  !isHiddenField(settings, DealerKeys.DEALER_C_ACTIVITY_TYPES)) {
    return (
      <ul className="dealer-activities">
        {dealerActivityTypes.map(activity => {
          if (activity in dealerActivityIcons && dealerActivityTypesVisibility.get(activity) === true) {
            const li = (
              <li className="dealer-activities__activity" key={activity}>
                <WorkbenchIcon icon={dealerActivityIcons[activity]} />
              </li>
            );
            const translation = dealerActivityTypesTranslations.get(activity);
            return translation ? (
              <WorkbenchTooltip key={activity} text={translation} position={props.tooltipPosition}>
                {li}
              </WorkbenchTooltip>
            ) : (
              li
            );
          }
        })}
      </ul>
    );
  }
  else return null;
}

export default DealerActivities;
